import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'artProof/calendar';

const calendarService = {
  getCalendarDays: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};
export default calendarService;
